import { BaseResponse } from '../../../../../../../types/api/api.types';
import { SendConsultationQuestionRequestData } from '../../../../../../../types/api/endpoints/consultations/questions.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[sendConsultationQuestionQuery]';

export const SEND_CONSULTATION_QUESTION_QUERY_KEY = 'SEND_CONSULTATION_QUESTION';

export const sendConsultationQuestionQuery = async (data: SendConsultationQuestionRequestData) => {
  console.log(PREFIX, `Sending consultation question...`);
  const response = await CONSULTATIONS_ENDPOINTS.sendQuestion(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Sent consultation question.`);
  return json as BaseResponse;
};
